import { useContext, useEffect, useState } from 'react';
import { ToastContext } from '../../../../contexts/ToastContext';
import apiModelo from '../../../../services/apis/apiModelo';
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '../../../../components/ui/dialog';
import {
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '../../../../components/ui/alert-dialog';
import { useParams } from 'react-router-dom';
import PaginationBar from '../../../../components/common/PaginationBar';
import apiMarca from '../../../../services/apis/apiMarca';
import apiEnum from '../../../../services/apis/apiEnum';

export default function ListaModelo({
	atualizarLista,
	pesquisar,
	funcaoModalController,
	onClose,
}) {
	const [listaMarca, setListaMarca] = useState([]);
	const [idEditar, setIdEditar] = useState();
	const [tipoEquipamento, setTipoEquipamento] = useState();
	const [nome, setNome] = useState('');
	const [marcaId, setMarcaId] = useState(0);
	const [tiposEquipamento, setTiposEquipamento] = useState([]);
	const [itemRemovido, setItemRemovido] = useState('');
	const [idRemover, setIdRemover] = useState();
	const [listaModelo, setListaModelo] = useState([]);
	const { erro, sucesso } = useContext(ToastContext);
	const {page} = useParams();
	const [pagination, setPagination] = useState();
	const funcaoModal = funcaoModalController.funcaoModal;

	//GET MODELO
	useEffect(() => {
		apiModelo.pagination(page).then((res) => {
			setListaModelo(res.data.items);
			setPagination(res.data);
		});
		
		apiMarca.fetchApi().then((res) => {
			setListaMarca(res.data);
		});
		apiEnum.getTiposEquipamento().then(res => {
			setTiposEquipamento(res.data);
		});
	}, [page]);

	//DELETE MODELO
	function deletar(id) {
		apiModelo
			.deleteApi(id)
			.then((res) => {
				atualizarLista();
				sucesso('Modelo deletado com sucesso!');
			})
			.catch((error) => {
				console.error(error.message);
				erro('Erro ao deletar modelo');
			});
	}

	function enviar(e) {
		e.preventDefault();

		const modelo = {
			nome: nome,
			marcaId: marcaId,
			tipoEquipamento:tipoEquipamento,
		};
		if (funcaoModal === 'Adicionar') {
			apiModelo
				.postApi(modelo)
				.then((res) => {
					atualizarLista();
					limparInputs();
					sucesso('Modelo adicionado com sucesso!');
					onClose();
				})
				.catch((error) => {
					console.error(error.message);
					erro('Erro ao adicionar modelo!');
				});
		} else if (funcaoModal === 'Editar') {
			apiModelo
				.putApi(idEditar, modelo)
				.then((res) => {
					atualizarLista();
					limparInputs();
					sucesso('Modelo editado com sucesso!');
					onClose();
				})
				.catch((error) => {
					console.error(error.message);
					erro('Erro ao editar modelo!');
				});
		}
	}

	function pegarNomeMarca(id) {
		try {
			const index = listaMarca.findIndex(
				(elemento) => elemento.id === id
			);
			return listaMarca[index].nome;
		} catch (error) {
			return '';
		}
	}

	function limparInputs() {
		setNome('');
		document.getElementById('marcaId').value = 0;
	}

	return (
		<>
			<Dialog>
				<div className="w-full flex flex-col items-center mt-[40px] md:px-[200px]">
					<table className="w-full">
						<thead className="border-b w-full">
							<tr>
								<th className="text-[25px] pl-[10px] text-start">
									Nome
								</th>
								<th className="text-[25px] pl-[10px] text-start">
									Tipo Equipamento
								</th>
								<th className="text-[25px] pl-[10px] text-start">
									Marca
								</th>
							</tr>
						</thead>
						<tbody>
							{listaModelo.map(
								(modelo, i) =>
									modelo.nome
										.toUpperCase()
										.startsWith(
											pesquisar.toUpperCase()
										) && (
										<tr
											className="border-b hover:bg-gray-200 hover:bg-opacity-5"
											key={i}
										>
											<td className="pl-[10px] text-[20px]">
												{
													modelo.nome
												}
											</td>
											<td className="pl-[10px] text-[20px]">
												{
													modelo.tipoEquipamento.replaceAll("_", " ")
												}
											</td>
											<td className="flex justify-between py-1">
												<span className="text-[20px] pl-[10px]">
													{pegarNomeMarca(
														modelo.marcaId
													)}
												</span>
												<span className="flex">
													<AlertDialogTrigger>
														<div
															onClick={() => {
																setIdEditar(
																	modelo.id
																);
																setNome(
																	modelo.nome
																);
																setMarcaId(
																	modelo.marcaId
																);
																setTipoEquipamento(
																	modelo.tipoEquipamento.replaceAll("_", " ")
																);
																funcaoModalController.setFuncaoModal(
																	'Editar'
																);
															}}
														>
															<i
																className="fa-solid fa-pen-to-square text-[18px] hover:text-lightBlue"
																title="Editar"
															></i>
														</div>
													</AlertDialogTrigger>
													<DialogTrigger>
														<div
															className="mx-2.5"
															onClick={() => {
																setItemRemovido(
																	modelo.nome
																);
																setIdRemover(
																	modelo.id
																);
															}}
														>
															<i
																className="fa-solid fa-trash text-[18px] hover:text-lightBlue"
																title="Deletar"
															></i>
														</div>
													</DialogTrigger>
												</span>
											</td>
										</tr>
									)
							)}
						</tbody>
					</table>
					{
						pagination !== undefined &&
						<PaginationBar pagination={pagination}/>
					}
				</div>

				<DialogContent>
					<DialogHeader>
						<DialogTitle>
							Excluir {itemRemovido}?
						</DialogTitle>
					</DialogHeader>
					<DialogDescription>
						Todos os dados associados com {itemRemovido}{' '}
						serão removidos.
					</DialogDescription>
					<DialogFooter>
						<div
							className="bg-red-600/70 py-2 px-4 rounded-md hover:bg-red-600 hover:cursor-pointer border-slate-800 border-2 transition-all duration-200 ease-in-out"
							onClick={() => deletar(idRemover)}
						>
							<DialogClose>Excluir</DialogClose>
						</div>
					</DialogFooter>
				</DialogContent>
			</Dialog>

			<AlertDialogContent>
				<form onSubmit={(e) => enviar(e)}>
					<AlertDialogHeader>
						<AlertDialogTitle>
							{funcaoModal} Modelo
						</AlertDialogTitle>
					</AlertDialogHeader>
					<div className="w-full flex justify-around my-5 px-10 flex-wrap">
						<div className="flex flex-col justify-end mr-2">
							<label
								htmlFor="nome"
								className="text-[18px] mb-2 pl-1"
							>
								Nome
							</label>
							<input
								id="nome"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								type="text"
								placeholder="nome do modelo"
								value={nome}
								onChange={(e) =>
									setNome(e.target.value)
								}
								required
							/>
						</div>

						<div className="flex flex-col justify-end ml-2">
							<label
								htmlFor="nome"
								className="text-[18px] mb-2 pl-1"
							>
								Marca{' '}
							</label>
							<select
								id="marcaId"
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="marcaId"
								value={marcaId}
								required
								onChange={(e) =>
									setMarcaId(
										parseInt(
											e.target.value
										)
									)
								}
							>
								<option label=" "> </option>
								{listaMarca.map(
									(elemento, i) => (
										<option
											value={
												elemento.id
											}
											key={i}
										>
											{
												elemento.nome
											}
										</option>
									)
								)}
							</select>
						</div>
						<div className="flex flex-col justify-end">
							<label
								htmlFor="tipoEquipamento"
								className="text-[18px] mb-2 pl-1 mt-5"
							>
								Tipo Equipamento{' '}
							</label>
							<select
								id="tipoEquipamento"
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="tipoEquipamento"
								value={tipoEquipamento}
								required
								onChange={(e) =>
									setTipoEquipamento(e.target.value)
								}
							>
								<option label=" "> </option>
								{
									tiposEquipamento.map((tipo, i) => (
										<option key={i} value={tipo}>{tipo}</option>	
									))
								}
							</select>
						</div>
					</div>
					<AlertDialogFooter>
						<div className="flex w-full justify-end gap-x-4 p-4">
							<AlertDialogAction className="w-32">
								Confirmar
							</AlertDialogAction>
							<div onClick={onClose}>
								<AlertDialogCancel className="w-32">
									Cancelar
								</AlertDialogCancel>
							</div>
						</div>
					</AlertDialogFooter>
				</form>
			</AlertDialogContent>

		</>
	);
}
